/**
 * Maps backend inspectable type strings to human-readable display names
 * (e.g., "AlarmDevice" -> "Alarm Device")
 */
const INSPECTABLE_TYPE_LABELS = {
    AlarmDevice: 'Alarm Device',
    AlarmSystem: 'Alarm System',
    Asset: 'Asset',
    CleanAgentSystem: 'Clean Agent System',
    Cylinder: 'Cylinder',
    DryValve: 'Dry Valve',
    Equipment: 'Equipment',
    FireDamper: 'Fire Damper',
    FireDoor: 'Fire Door',
    FireExitSign: 'Fire Exit Sign',
    FireExtinguisher: 'Fire Extinguisher',
    FireHose: 'Fire Hose',
    FirePumpInfo: 'Fire Pump',
    HoseValve: 'Hose Valve',
    InspectorsTestValve: 'Inspectors Test Valve',
    InternalCheckValve: 'Internal Check Valve',
    InternalPipe: 'Internal Pipe',
    KitchenHoodInfo: 'Kitchen Hood',
    MonitoringSystem: 'Monitoring System',
    'MonitoringSystems::Device': 'Monitoring System Device',
    PressureReducingValve: 'Pressure Reducing Valve',
    SpecialHazard: 'Special Hazard',
    System: 'System',
    Valve: 'Valve'
};
export function humanizeInspectableType(type) {
    if (!type) {
        return 'Device';
    }
    return INSPECTABLE_TYPE_LABELS[type] || type;
}
export function isKnownAssetType(type) {
    return !!type && Object.prototype.hasOwnProperty.call(INSPECTABLE_TYPE_LABELS, type);
}
